import React, {  useCallback } from 'react'
import { Link } from 'react-router-dom'
import { formatUserTitleAndOrganization } from '../../helpers/stringHelpers'

const HEADER_COLOR = '#909092'

const WizardHeader = ({ activeTab, wizard }) => {
  const { currentUser, visitingOneOnOneWizardFrom } = window

  const url = window.location.pathname
  const token = url.split('/')[1]

  const highlightNavItems = useCallback((activeTab, index) => {
    if(activeTab == 'profile') return HEADER_COLOR
    else{
      if(activeTab === 'wishlist'){
        return index > 1 ? HEADER_COLOR : 'inherit'
      }else if(activeTab === 'wishlist_rank'){
        return index > 2 ? HEADER_COLOR : 'inherit'
      }
      else{
        return 'inherit'
      }
    }
  }, [activeTab])

  return(
    <div>
      {!!wizard &&
      <div className="wizard-header">
        {visitingOneOnOneWizardFrom ? '' :
          <div className='welcome'>
            <h2>Welcome { currentUser.first_name } { currentUser.last_name }</h2>
            <h5>{formatUserTitleAndOrganization(currentUser.title, currentUser.organization_name)}</h5>
          </div>
        }
        <p>Thank you for taking part in peer-to-peer meetings. To personalize your experience, please complete the following steps.</p>
        <div className='wizard-links'>
          <div className='profile-nav'>
            <Link
              to={'/' + token + '/profile/wizard'}
              className={ activeTab == 'profile' ? 'my-details active' : 'my-details'} >
              MY DETAILS
            </Link>
          </div>
          <span className='link-divider'></span>
          <div className='wizard-nav'>
            <div className={ activeTab == 'wishlist' ? 'active' : ''} >
              <a style={{ color: highlightNavItems(activeTab, 1)}}>MY PREFERENCES</a>
            </div>
            <div className={ activeTab == 'wishlist_rank' ? 'active' : ''} >
              <a style={{ color: highlightNavItems(activeTab, 2)}}>RANK PREFERENCES</a>
            </div>
            <div className={ activeTab == 'availability' ? 'active' : ''} >
              <a style={{ color: highlightNavItems(activeTab, 3)}}>AVAILABILITY</a>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  )
}

export default WizardHeader
